module.exports = __webpack_public_path__ + "fe8978ff653937af87cd84424837bd90.fbx";